function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgArCondicionado = function SvgArCondicionado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.458 13.97l1.974-2.007V9.867l-3.874-4.374a.5.5 0 01.748-.663l3.126 3.529V2a.5.5 0 111 0v6.359l3.126-3.53a.5.5 0 01.748.664l-3.874 4.374v2.096l1.974 2.006 2.496-1.464 1.791-5.597a.5.5 0 11.953.305l-1.451 4.533 5.416-3.177a.5.5 0 11.506.862l-5.436 3.19 4.594.99a.5.5 0 01-.211.978l-5.658-1.22-2.277 1.335.93.945a.5.5 0 010 .702l-.93.945 2.277 1.335 5.658-1.22a.5.5 0 01.21.977l-4.593.991 5.436 3.19a.5.5 0 01-.506.862l-5.416-3.177 1.45 4.533a.5.5 0 11-.952.305l-1.79-5.597-2.497-1.464-1.974 2.006v2.096l3.874 4.374a.5.5 0 11-.748.663l-3.126-3.529V30a.5.5 0 11-1 0v-6.359l-3.126 3.53a.5.5 0 01-.748-.664l3.874-4.374v-2.096l-1.974-2.006-2.497 1.465-1.79 5.596a.5.5 0 11-.953-.305l1.45-4.533-5.415 3.177a.5.5 0 01-.506-.862l5.436-3.19-4.594-.99a.5.5 0 01.21-.978l5.659 1.22 2.276-1.335-.93-.945a.5.5 0 010-.702l.93-.945-2.276-1.336L4.8 14.59a.5.5 0 11-.211-.977l4.594-.991-5.436-3.19a.5.5 0 11.506-.862l5.415 3.177-1.45-4.533a.5.5 0 11.952-.305l1.791 5.596 2.497 1.465zm.447.97a.496.496 0 01-.016.017L12.862 16l1.022 1.038a.496.496 0 01.026.027l2.016 2.048a.51.51 0 01.012 0l2.016-2.048a.496.496 0 01.026-.027L19.002 16l-1.025-1.041a.496.496 0 01-.02-.02l-2.019-2.052a.512.512 0 01-.012 0l-2.02 2.053z"
  }));
};
SvgArCondicionado.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgArCondicionado.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgArCondicionado;